import Marquee from "react-fast-marquee";

const items = [
  "DOWSIL™ Silicone Sealants",
  "Chennai Express Urad Dhal",
  "Wopper Laundry Chemicals",
  "Authorised Dealer",
  "Wholesale & Retail",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative z-10 border-y border-white/10 bg-black py-10"
      data-testid="marquee-section"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display marquee-outline px-8 text-4xl font-light tracking-tight sm:text-6xl lg:text-7xl">
              {item}
            </span>
            <span className="text-white/25 text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
